function getLocal(){
  return window.location.host
}

module.exports = {
  // BASE_API:getLocal()
  // BASE_API:'wwj1110.ltd:12121/'
  // BASE_API:'47.103.207.23:12121/'
  BASE_API:'www.mobsavatar.com/'
  // BASE_API:"192.168.1.129:7749"
  // BASE_API:"47.100.165.71:7749"
}